import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { MIN_FONT_SIZE } from '../../../theme/typography';

export const LOGGED_UTILISATION_HREF = '/timesheets?tab=reports';

/**
 * The one line a planned-utilisation surface carries to say where the other
 * figure lives. Ungated: the caller decides with `useCanOpenLoggedUtilisation`,
 * so a presentational list stays renderable without an auth context.
 */
export function LoggedUtilisationLink() {
  return (
    <Typography
      data-testid="logged-utilisation-link"
      sx={{ fontSize: MIN_FONT_SIZE, color: 'text.secondary' }}
    >
      Logged utilisation (hours on timesheets) is in{' '}
      <Link component={RouterLink} to={LOGGED_UTILISATION_HREF} sx={{ fontWeight: 600 }}>
        Timesheets → Reports
      </Link>
    </Typography>
  );
}
